(() => {
    class PreviewModalController {
        constructor(
            $scope,
            $state,
            $sce,
            $uibModalInstance,
            content,
            brandClass
        ) {
            $scope.content = $sce.trustAsHtml(content)
            $scope.brandClass = brandClass
            $scope.close = function () {
                $uibModalInstance.close()
                $state.go("app.landingpages.edit", {
                    preview: ''
                })
            }
        }
    }

    angular
        .module('dashboard')
        .controller('previewModal', [
            '$scope',
            '$state',
            '$sce',
            '$uibModalInstance',
            'content',
            'brandClass',
            PreviewModalController ]);

})();
